const config = {
  appId: '647ee6a3cca9c147bb8074cc',
  region: 'eu-1',
  businessIconUrl: '/assets/images/webchat.svg',
  businessName: 'EenVandaag',
  buttonIconUrl: '/assets/images/webchat.svg',
  locale: 'nl-NL',
  customText: {
    actionPostbackError:
      'Er is een fout opgetreden bij het verwerken van deze actie. Probeer het opnieuw.',
    clickToRetry: 'Bericht niet afgeleverd. Klik om opnieuw te proberen.',
    clickToRetryForm:
      'Formulier niet verzonden. Klik ergens op het formulier om opnieuw te proberen.',
    connectNotificationText:
      'Synchroniseer je gesprek en blijf met ons communiceren via jouw favoriete app.',
    connectNotificationSingleText: 'Word op de hoogte gebracht wanneer je een antwoord krijgt.',
    conversationListHeaderText: 'Mijn gesprekken',
    conversationListPreviewAnonymousText: 'Iemand',
    conversationListPreviewCarouselText: '{user} heeft een bericht gestuurd',
    conversationListPreviewFileText: '{user} heeft een bestand gestuurd',
    conversationListPreviewFormText: '{user} heeft een formulier gestuurd',
    conversationListPreviewFormResponseText: '{user} heeft een formulier ingevuld',
    conversationListPreviewImageText: '{user} heeft een afbeelding gestuurd',
    conversationListPreviewLocationRequestText: '{user} heeft een locatieverzoek gestuurd',
    conversationListPreviewUserText: 'Jij',
    conversationListRelativeTimeJustNow: 'Zojuist',
    conversationListRelativeTimeMinute: '1 minuut geleden',
    conversationListRelativeTimeMinutes: '{value} minuten geleden',
    conversationListRelativeTimeHour: '1 uur geleden',
    conversationListRelativeTimeHours: '{value} uur geleden',
    conversationListRelativeTimeYesterday: 'Gisteren',
    conversationListTimestampFormat: 'DD/MM/YY',
    conversationTimestampHeaderFormat: 'DD MMMM, HH:mm',
    couldNotConnect: 'Offline. Je zult geen berichten ontvangen.',
    couldNotConnectRetry: 'Opnieuw verbinding maken...',
    couldNotConnectRetrySuccess: 'Je bent weer online!',
    couldNotLoadConversations: 'Kan geen gesprekken laden.',
    emailChangeAddress: 'Verander mijn e-mail',
    emailDescription:
      'Voer jouw e-mailadres in om per e-mail op de hoogte te worden gesteld wanneer je een antwoord ontvangt.',
    emailFieldLabel: 'E-mail',
    emailFieldPlaceholder: 'Jouw e-mailadres',
    emailFormButton: 'Verzenden',
    emailLinkingErrorMessage: 'Voer een geldig e-mailadres in.',
    fetchHistory: 'Meer laden',
    fetchingHistory: 'Geschiedenis ophalen...',
    fileTooLargeError: 'Maximale bestandsgrootte overschreden ({size})',
    fileTypeError: 'Niet-ondersteund bestandstype.',
    formErrorInvalidEmail: 'E-mail is ongeldig',
    formErrorNoLongerThan: 'Mag niet meer dan ({characters}) tekens bevatten',
    formErrorNoShorterThan: 'Moet ten minste ({characters}) tekens bevatten',
    formErrorUnknown: 'Dit ziet er niet helemaal goed uit',
    frontendEmailChannelDescription:
      'Om met ons te communiceren via e-mail, stuur gewoon een bericht naar ons e-mailadres en we antwoorden snel:',
    headerText: 'Hoe kunnen we helpen?',
    imageClickToReload: 'Klik om afbeelding opnieuw te laden.',
    imageClickToView: 'Klik om afbeelding van {size} te bekijken.',
    imagePreviewNotAvailable: 'Preview niet beschikbaar.',
    inputPlaceholder: 'Typ je bericht...',
    inputPlaceholderBlocked: 'Vul het formulier hierboven in',
    introAppText: 'Stuur ons hieronder een bericht of vanuit jouw favoriete app.',
    introductionText:
      'Hier kun je jouw vragen stellen over de onderwerpen van EenVandaag. Wil je liever met ons appen, stuur dan een appje naar <a href="https://wa.me/31622468988" target="_blank" rel="noopener">0622468988</a>.',
    linkError:
      'Er is een fout opgetreden bij het genereren van een link voor dit kanaal. Probeer het opnieuw.',
    linkChannelPageHeader: 'Synchroniseer jouw gesprek',
    locationNotSupported:
      'Jouw browser ondersteunt geen locatieservices of deze zijn uitgeschakeld. Typ in plaats daarvan jouw locatie.',
    locationSecurityRestriction:
      'Deze website kan geen toegang krijgen tot jouw locatie. Typ in plaats daarvan jouw locatie.',
    locationSendingFailed: 'Locatie kon niet worden verzonden',
    locationServicesDenied:
      'Deze website kan geen toegang krijgen tot jouw locatie. Sta toegang toe in jouw instellingen of typ in plaats daarvan jouw locatie.',
    messageIndicatorTitlePlural: '({count}) nieuwe berichten',
    messageIndicatorTitleSingular: '({count}) nieuw bericht',
    messageRelativeTimeDay: '{value}d geleden',
    messageRelativeTimeHour: '{value}u geleden',
    messageRelativeTimeJustNow: 'Zojuist',
    messageRelativeTimeMinute: '{value}m geleden',
    messageTimestampFormat: 'h:mm A',
    messageDelivered: 'Bezorgd',
    messageSeen: 'Gezien',
    messageSending: 'Verzenden...',
    messengerChannelDescription:
      'Koppel jouw Facebook Messenger-account om op de hoogte te worden gebracht wanneer je een antwoord krijgt en het gesprek op Facebook Messenger voort te zetten.',
    newConversationButtonText: 'Nieuw gesprek',
    notificationSettingsChannelsDescription:
      'Synchroniseer dit gesprek door verbinding te maken met jouw favoriete berichten-app om het gesprek op jouw manier voort te zetten.',
    notificationSettingsChannelsTitle: 'Andere kanalen',
    notificationSettingsConnected: 'Verbonden',
    notificationSettingsConnectedAs: 'Verbonden als {username}',
    prechatCaptureGreetingText: 'Welkom bij EenVandaag',
    prechatCaptureNameLabel: 'Jouw naam',
    prechatCaptureNamePlaceholder: 'Typ je naam...',
    prechatCaptureEmailLabel: 'E-mail',
    prechatCaptureEmailPlaceholder: 'naam@bedrijf.com',
    prechatCaptureConfirmationText: 'Dankjewel. Wat wil je vragen?',
    prechatCaptureMailgunLinkingConfirmation:
      'Je ontvangt hier en per e-mail op {email} bericht zodra we antwoorden.',
    sendButtonText: 'Stuur',
  },
  customColors: {
    brandColor: '000a45',
  },
};

export default config;
